module.exports = __webpack_public_path__ + "static/media/6.707fd572.png";